import { v4 as uuidv4 } from 'uuid';

export const REQUEST_ID_HEADER = 'x-request-id';

export function createRequestId(): string {
  return uuidv4();
}

export function withRequestId(headers?: HeadersInit): Headers {
  const next = new Headers(headers);
  if (!next.has(REQUEST_ID_HEADER)) {
    next.set(REQUEST_ID_HEADER, createRequestId());
  }
  return next;
}

/**
 * Headers for public, cacheable Next.js `fetch` calls (`next.revalidate`).
 * Omits a unique `x-request-id` so the Data Cache key stays stable across
 * Link prefetch and soft navigations.
 */
export function publicCacheHeaders(
  headers?: HeadersInit
): Record<string, string> {
  const next = new Headers(headers);
  next.delete(REQUEST_ID_HEADER);
  if (!next.has('Content-Type')) {
    next.set('Content-Type', 'application/json');
  }
  return Object.fromEntries(next.entries());
}
